module.exports = __webpack_public_path__ + "static/autobiography-of-a-yogi-b11142b8f45d0522d4d783404a647f91.jpg";